import { NessieThemeColors } from "@classdojo/web/nessie/components/theme";

type FullWidthButtonProps = {
  text: string;
  onClick: VoidFunction;
  disabled?: boolean;
  bgColor?: NessieThemeColors;
  textColor?: NessieThemeColors;
  maxWidth?: number;
  /**
   * The name will get used for automated product events.
   * @see https://www.notion.so/classdojo/Automatic-Product-Events-for-Web-bfc580f10a914c3ba514e5ec20f8ef9e?pvs=4
   */
  "data-name": string;
};

export default function FullWidthButton({
  text,
  onClick,
  disabled,
  bgColor = "dt_content_accent",
  textColor = "dt_content_light",
  maxWidth,
  "data-name": dataName,
}: FullWidthButtonProps) {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      data-name={dataName}
      sx={{
        borderRadius: "dt_radius_m",
        width: "100%",
        backgroundColor: disabled ? "dt_content_disabled" : bgColor,
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
      }}
    >
      <div sx={{ color: textColor, fontWeight: 600, fontSize: 18 }}>{text}</div>
    </div>
  );
}
